import { TranslateLoader } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { AuthenticationService } from '../services/authentication.service';

export class HttpLanguageLoader implements TranslateLoader {

    constructor(
        public httpClient: HttpClient,
        public authenticationService: AuthenticationService
    ) { }
    
    getTranslation(lang: string): Observable<any> {
        let result: Observable<any> = new Observable((subscriber) => {
            this.authenticationService.Authenticated.subscribe(value => {
                if (value) {
                    this.authenticationService
                    .getAuthToken()
                    .subscribe(token => {
                        const gotLang = this.authenticationService && this.authenticationService.userInfoView && this.authenticationService.userInfoView.SelectedClient && this.authenticationService.userInfoView.SelectedClient.Lang;
                        let actualLang = gotLang ? this.authenticationService.userInfoView.SelectedClient.Lang : lang;
                        this.callApi(actualLang, token).toPromise()
                        .then(apiResult => {
                            subscriber.next(apiResult);
                        });
                    });
                }
            });
        });
        return result;
    }

    /**
     * Gets the proper translations from the api.
     */
    public callApi(lang: string, token: any) {
        let url = environment.metricsApiUrl;
        url = url.charAt(url.length) === '/' ? url : url + '/';
        let endpoint = `${url}mobile-metrics/static-translations/${lang}`;
        const headers = new HttpHeaders().set('Authorization', `Bearer ${token.AccessToken}`);
        return this.httpClient.get(endpoint, {headers,  withCredentials: true});
    }
}